import { retornoHashValor } from '../../modulos/cripotografia/hash';
import apiZelo from '../backAxiosVendaToken';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');
let retorno;

export const Buscas = async relative_path => {
    await fetch(url + relative_path, {
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson.length > 0) {
                retorno = responseJson;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err.message;
        });

    return retorno;
};

export const buscarParentescoPorPlano = async plano => {
    try {
        const respostaBusca = await apiZelo.get(
            `/parentesco/plano/${plano}?status=true`
        );

        return respostaBusca.data;
    } catch (error) {
        return error;
    }
};

export const buscarAssociado = async inscricao => {
    try {
        const respostaAssociado = await apiZelo.get(
            `/Associados/${inscricao}`
        );

        return respostaAssociado.data;
    } catch (error) {
        return error;
    }
};

export const BuscarDependentes = async (relative_path, contratoUpSell) => {
    const nomePatch = contratoUpSell ? '/upsell/dependentes' : '/dependentes';

    try {
        const respostaBusca = await apiZelo.get(
            `${nomePatch}/${relative_path}`
        );

        return respostaBusca.data;
    } catch (err) {
        return err.message;
    }
};

export const insereDependente = async (relative_path, dependente, contratoUpSell) => {
    if (dependente.Email == '') { delete dependente.Email; }

    let nomePatch = '/dependentes';
    let infoDependente = dependente;

    if (contratoUpSell) {
        nomePatch = '/upsell/dependentes';
        delete dependente?.Pagador;

        if (dependente.TipoPet && dependente.PesoPet) {
            infoDependente = {
                ...dependente,
                TipoPet: dependente.TipoPet?.toString(),
                PesoPet: dependente.PesoPet?.toString(),
                Porte: dependente.Porte?.toString()
            };
        }
    }

    try {
        const responseInsert = await apiZelo.post(
            `${nomePatch}/${relative_path}`,
            infoDependente
        );

        return responseInsert;
    } catch (err) {
        return err.message;
    }
};

export const removeDependente = async (relative_path, seq, contratoUpSell) => {
    const nomePatch = contratoUpSell ? '/upsell/dependentes' : '/dependentes';

    if (!contratoUpSell) {
        try {
            const responseDelete = await apiZelo.delete(
                `${nomePatch}/${relative_path}`,
                { data: { Seq: seq } }
            );

            return responseDelete.data;
        } catch (err) {
            return err.message;
        }
    } else {
        try {
            const responseDelete = await apiZelo.delete(
                `${nomePatch}/${relative_path}/${seq}`
            );

            return responseDelete.data;
        } catch (err) {
            return err.message;
        }
    }
};

export const ativarDesativarDep = async (body, inscricao, seq) => {
    try {
        await apiZelo.patch(
            `upsell/dependentes/${inscricao}/${seq}`,
            body
        );
    } catch (err) {
        return err.message;
    }
};

export const atualizaDependente = async (dependente, inscricao, contratoUpSell) => {
    if (dependente.Email == '') { delete dependente.Email; }

    if (!contratoUpSell) {
        try {
            delete dependente?.status;

            const responseUpdate = await apiZelo.put(
                `/dependentes/${inscricao}`,
                dependente
            );

            return responseUpdate.data;
        } catch (err) {
            return err.message;
        }
    } else {
        try {
            const seq = dependente?.Seq;

            delete dependente?.Seq;
            delete dependente?.Pagador;
            dependente.Porte = dependente.Porte ? dependente.Porte.toString() : null;
            dependente.TipoPet = dependente.TipoPet ? dependente.TipoPet.toString() : null;
            dependente.PesoPet = dependente.PesoPet ? dependente.PesoPet.toString() : null;

            const responseUpdate = await apiZelo.patch(
                `upsell/dependentes/${inscricao}/${seq}`,
                dependente
            );

            return responseUpdate;
        } catch (err) {
            return err.message;
        }
    }
};
